(function() {
  'use strict';

  angular.module('iv.iform', ['restangular', 'ngSanitize']);

})();

(function () {
  'use strict';

  angular
    .module('iv.iform')
    .config(config);

  config.$inject = [];
  function config() {
  }

})();

(function () {
  'use strict';

  angular
    .module('iv.iform')
    .run(runBlock);


  runBlock.$inject = [];
  function runBlock() {
  }
})();

(function() {
  'use strict';

  function ivIform() {
    var _this = this;
    var _apiBaseUrl = null;

    _this.$get  = service;

    /**
     * Service definition
     *
     * @returns {Object}
     */

    service.$inject  = ['Restangular'];

    function service(Restangular) {

      return{
        getRestangularClient :getRestangularClient
      };

      function getRestangularClient(){
        if(_apiBaseUrl !== null){
          return Restangular.withConfig(function(RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(_apiBaseUrl);
            RestangularConfigurer.setDefaultHeaders({"X-Requested-With": "XMLHttpRequest"});
          });
        } else {
          throw 'No iForm api base url provided. Make sure attribute form-base isset.';
        }
      }
    }

    /**
     * Provider methods
     * Set the api url which is used to post the form to
     */

    _this.setApiBaseUrl = function(apiBaseUrl) {
      if(typeof apiBaseUrl === 'string') {
        _apiBaseUrl = apiBaseUrl;
      }

      return _this;
    };


  }

  angular.module('iv.iform')
    .provider('ivIform', ivIform);

})();



(function () {
  'use strict';

  iformService.$inject = ['ivIform'];

  function iformService(ivIform) {
    var Restangular = ivIform.getRestangularClient();

    var _formRoute = Restangular.all('/iform/v1/form');

    return {
      getForm : getForm,
      postForm: postForm
    };

    // GET the form JSON
    function getForm(formId, language) {
      return _formRoute.customGET(formId,{languageIso: language.toUpperCase()});
    }

    // POST the completed form
    function postForm(formId, data) {
      // check if there are files that need to be uploaded
      var _aFiles = _checkForFiles(data);
      if (_aFiles.length) {
        // when uploading files, we need to POST the form as FormData instead of JSON
        var _formData = new FormData();
        _aFiles.forEach(function(fileBlock){
          _formData.append('iFrm_PstFld['+fileBlock.id+']', fileBlock.value);
        });

        // add all none file related fields as a string to the payload field
        _formData.append('payload', JSON.stringify(data));

        return _formRoute.one(formId).withHttpConfig({
          transformRequest: angular.identity,
          timeout         : 0
        }).customPOST(_formData, undefined, undefined, {
          'Content-Type': undefined
        });

      } else {
        // no files, post as JSON
        return _formRoute.one(formId).post(null,data);
      }
    }


    function _checkForFiles(data) {
      // check if there are files that need to be uploaded. Loop all blocks
      var aFiles = [];
      for(var key in data.pages) {
        var page = data.pages[key];
        for(var blockKey in page.blocks) {
          var block = page.blocks[blockKey];
          if(block.bSelectedAFile){
            aFiles.push(block);
          }
        }
      }
      return aFiles;
    }

  }

  angular.module('iv.iform')
    .factory('iformService', iformService);

})();

(function () {
  'use strict';

  ivIform.$inject = ['iformService'];

  function ivIform(iformService) {
    var _pageObject = {
      id    : null,
      blocks: []
    };

    var _inputModel = {
      id: null
    };


    return {
      restrict   : 'EAC',
      templateUrl: 'scripts/directives/iform.tpl.html',
      scope      : {
        formId          : '@formId',
        formLanguage    : '@formLanguage',
        formCustomClass : '@formCustomClass',
        formBase        : '@formBase',
        beforeSend      : '&?beforeSend',
        afterSend       : '&?afterSend',
      },
      link       : function (scope, elm, attrs, ctrl) {

        // public variables
        scope.bShowForm             = false;
        scope.formData              = null;
        scope.form                  = {
          id   : null,
          pages: []
        };
        scope.validators            = [];
        scope.currentPage           = 0;
        scope.bShowSuccessMessage   = false;
        scope.bShowErrorMessage     = false;
        scope.errorMessage          = null;
        scope.settings              = {};


        // If the language of the form isn't set. fallback to default language 'NL'
        if (typeof scope.formLanguage === 'undefined') {
          scope.formLanguage        = 'NL';
        }

        // public function definitions
        scope.nextPage                = nextPage;
        scope.prevPage                = prevPage;
        scope.send                    = send;
        scope.clearRadioOtherField    = clearRadioOtherField;
        scope.clearCheckboxOtherField = clearCheckboxOtherField;
        scope.setOtherChoice          = setOtherChoice;
        scope.checkDependencies       = checkDependencies;

        // public functions
        function nextPage() {
          if (scope.validators[scope.currentPage].$valid) {
            scope.currentPage++;
          }
        }

        function prevPage() {
          scope.currentPage--
        }

        function send() {
          if (scope.beforeSend) {
            scope.beforeSend();
          }

          // send completed form to api
          if(!_bSending){
            var _bSending = true;
            if (scope.validators[scope.currentPage].$valid) {
              iformService.postForm(scope.formId, scope.form)
                .then(_formCompleted, _errorHander)
                .finally(function () {
                  _bSending = false;
                  if (scope.afterSend) {
                    scope.afterSend();
                  }
                });
            }
          }
        }

        function clearRadioOtherField(bHasOtherChoice, field) {
          // clear the other input field if the user unchecks the 'other' radio button
          if (bHasOtherChoice) {
            delete field.other_input;
          }
        }

        function clearCheckboxOtherField(field) {
          // clear the other input field if the user unchecks the 'other' checkbox
          if (typeof field.other_value === 'undefined') {
            delete field.other_input;
          }
        }

        function setOtherChoice(field, multiplechoice_type) {
          // check the input checkbox or radiobutton if the user puts focus on the other text field
          if (multiplechoice_type === 'radio') {
            field.choice      = 'other_value';
          }
          if (multiplechoice_type === 'checkbox') {
            field.other_value = 'other_value';
          }
        }

        function checkDependencies(aDependencies, choices) {
          var _currentInputId = choices.id;

          // check if the changed input has dependencies
          if(aDependencies.length){
            // check if there is a form - should be obvious
            if(typeof scope.formData !== 'undefined' && typeof scope.formData.pages !== 'undefined'){
              // loop over all dependencies coupled to this input field
              aDependencies.forEach(function(dependency){
                // loop over all pages and its blocks to find the corresponding input of the dependency
                scope.formData.pages.forEach(function(page){
                  page.blocks.forEach(function(block){

                    // compare the block's id to the dependency block id.
                    if(block.id === dependency.form_block){

                      // Check for dependencies on condition type 'equals'
                      if(dependency.condition === 'equals'){
                        var _bMeetsCondition = false;

                        // loop over all current choices, if one of the selected values matches the dependency value the condition is met.
                        for(var prop in choices) {
                          if (choices.hasOwnProperty(prop)) {
                            if(choices[prop] === dependency.value){
                              _bMeetsCondition = true;
                            }
                          }
                        }


                        if(typeof block.meetsConditionOf === 'undefined'){
                          block.meetsConditionOf = [];
                        }
                        // Check if the meetsConditionOf array already contains the current input his id
                        var _indexOfCondition = block.meetsConditionOf.indexOf(_currentInputId);

                        // check if a dependency condition is met
                        if(_bMeetsCondition){
                          // the input is not yet added to the blocks meetsConditionOf array. Add the input. A input block can meet multiple conditions.
                          if(_indexOfCondition === -1){
                            block.meetsConditionOf.push(_currentInputId);
                          }
                        } else {
                          // if the dependency condition is not met, remove the input id from the array
                          if (_indexOfCondition > -1) {
                            block.meetsConditionOf.splice(_indexOfCondition, 1);
                          }
                        }


                        if(_bMeetsCondition){
                          switch (dependency.type){
                            case 'VISIBLE':
                              block.show = true;
                              break;
                            case 'HIDDEN':
                              block.show = false;
                              break;
                          }
                        } else {
                          // The condition was not met. If there are other conditions that still are met. The items visibility doens't need to be toggled.
                          // If there none met. Hide the item.
                          if(block.meetsConditionOf.length === 0){
                            switch (dependency.type){
                              case 'VISIBLE':
                                block.show = false;
                                break;
                              case 'HIDDEN':
                                block.show = true;
                                break;
                            }
                          }
                        }
                      }
                    }
                  });
                });
              });

            }
          }
        }

        // private functions

        // Get the form JSON from the api.
        function _getForm() {
          // a formid is required to make the api call
          if (typeof scope.formId !== 'undefined' && scope.formId) {

            iformService.getForm(scope.formId, scope.formLanguage).then(function (response) {
              scope.form.id = response.id;

              // bind form JSON to formData property. Used to loop over the form template.
              scope.formData = response;

              // create settings object
              if(typeof response.settings !== 'undefined'){
                response.settings.forEach(function(setting){
                  scope.settings[setting.type] = setting.value;
                });
              }

              // Generate page objects, and add them to the pages array. This will be used to add input models from the template.
              scope.formData.pages.forEach(function (item) {
                // create page object
                var _page = angular.copy(_pageObject);
                // set id of form to send back to api
                _page.id = item.id;

                item.blocks.forEach(function (block) {
                  //create a model for each block
                  var _model = angular.copy(_inputModel);
                  _model.id = block.id;

                  switch (block.multiplechoice_type) {
                    case 'radio':
                      // set preselected choice
                      _model.choice = block.selected_choice;
                      break;
                    case 'checkbox':
                      // set preselected value for checkboxes
                      if(typeof block.selected_choice !== "undefined"){
                        _model[block.selected_choice] = block.selected_choice;
                      }
                      break;
                    case 'dropdown':
                      // set preselected value for dropdowns
                      _model.value = block.selected_choice;
                      break;
                    default:
                      // set preselected values other fields
                      _model.value = block.content;
                  }

                  _page.blocks.push(_model);
                });


                scope.form.pages.push(_page);

              });

              // Show form when done creating the form.
              scope.bShowForm = true;
            });
          }
        }

        function _errorHander(response) {
          if(typeof response.error !== 'undefined' && typeof response.message !== 'undefined' && response.error){
            scope.errorMessage        = response.message;
            scope.bShowErrorMessage   = true;
          }
        }

        function _formCompleted(response) {
          // if completed reset form to default
          if(typeof response.success !== 'undefined' && response.success){
            scope.bShowSuccessMessage = true;
            scope.bShowErrorMessage   = false;
            scope.errorMessage        = null;
            scope.bShowForm           = false;
          } else {
            // not successful handle error
            _errorHander(response);
          }
        }

        _getForm();
      }
    };
  }

  angular.module('iv.iform')
    .directive('ivIform', ivIform)
})();

(function() {
  'use strict';

  function iformFileInput() {
    // the file upload directive.
    return {
      restrict      : 'A',
      require       :'ngModel',
      scope         : {
        iformFileInput             : "=iformFileInput",
        'isRequired'          : '=isRequired'
      },
      link: function(scope, elm, attrs, ctrl) {
        //Set the validity of the field if its required
        if(scope.isRequired){
          ctrl.$setValidity('isRequired', (elm.val() !== ''));
        }

        elm.bind("change", function (changeEvent) {
          // check the validity of the field if its required
          if(scope.isRequired){
            ctrl.$setValidity('isRequired', (elm.val() !== ''));
          }

          scope.$apply(function () {
            if(changeEvent.target.files.length && scope.iformFileInput){
              // store the data in a value property.
              scope.iformFileInput.value = changeEvent.target.files[0];
              scope.iformFileInput.bSelectedAFile = true;
              // store the name in a property so it can be used in the custom layout of the upload field.
              if(changeEvent.target.files[0].name){
                scope.iformFileInput.name  = changeEvent.target.files[0].name;
              }
            } else {
              // no selected file to upload anymore. Clear all data
              delete scope.iformFileInput.bSelectedAFile;
              delete scope.iformFileInput.value;
              delete scope.iformFileInput.name;
            }
          });
        });
      }
    };
  }

  angular.module('iv.iform')
    .directive('iformFileInput', iformFileInput)
})();

(function() {
  'use strict';

  function iformCheckNumber() {
    // check if the inserted value is a digit. Set te validity of the field depending on the result
    return {
      restrict  : 'A',
      require   : 'ngModel',
      link: function (scope, elm, attrs, ctrl) {
        var _NUMBER_REGEXP = /^\d+$/;

        function fromUser(text) {
          if(text){
            if (text.length) {
              ctrl.$setValidity('iformCheckNumber', _NUMBER_REGEXP.test(text));
            }
            return text;
          } else {
            ctrl.$setValidity('iformCheckNumber', true);
          }
          return '';
        }

        ctrl.$parsers.unshift(fromUser);
        ctrl.$formatters.unshift(fromUser);
      }
    };
  }

  angular.module('iv.iform')
    .directive('iformCheckNumber', iformCheckNumber)
})();

(function() {
  'use strict';

  function iformNumberBoundary() {
    // check if a number is between and upper en lower limit.
    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope: {
        text      : '=ngModel',
        lowerLimit: "=lowerLimit",
        upperLimit: "=upperLimit"
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watch('text', function() {
          if(scope.text){
            var _number = parseInt(scope.text);
            if(_number >= scope.lowerLimit && _number <= scope.upperLimit){
              ctrl.$setValidity('iformNumberBoundary', true);
            } else {
              ctrl.$setValidity('iformNumberBoundary', false);
            }
          }
        });
      }
    };
  }

  angular.module('iv.iform')
    .directive('iformNumberBoundary', iformNumberBoundary)
})();

(function() {
  'use strict';

  function iformCheckEmail() {
    // this regex has to be the same as the one used in iManager. Changing it here doenst make the email address valid for posting
    var EMAIL_REGEXP = /^([A-Za-z0-9_\-\+\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope     : {
        'email'    : '=ngModel'
      },
      link: function(scope, elm, attrs, ctrl) {
        scope.$watch('email', function() {
          if(angular.isDefined(scope.email) && angular.isString(scope.email) && scope.email.length){
            ctrl.$setValidity('iformCheckEmail', EMAIL_REGEXP.test(scope.email));
          }
        });
      }
    };
  }

  angular.module('iv.iform')
    .directive('iformCheckEmail', iformCheckEmail)
})();

(function() {
  'use strict';

  function iformCountCheckboxes() {
    // check if the number of checkboxes that are checked comply with the validation rules set for this field
    return {
      require   : 'ngModel',
      restrict  : 'A',
      scope     : {
        'checkboxModel'       : '=',
        'minCheckboxes'       : '=minCheckboxes',
        'minCheckboxValue'    : '=minCheckboxValue',
        'maxCheckboxes'       : '=maxCheckboxes',
        'maxCheckboxValue'    : '=maxCheckboxValue',
        'groupIsRequired'     : '=groupIsRequired'
      },
      link: function(scope, elm, attrs, ctrl) {

        if(typeof scope.checkboxModel !== 'undefined'){
          scope.$watch('checkboxModel', function(newValue, oldValue) {

            // loop over the properties and remove undefined values. Only defined properties are selected checkboxes
            for(var key in newValue) {
              if(typeof newValue[key] === 'undefined' || !newValue[key]) {
                delete newValue[key];
              }
            }

            // The model can have reserved properties that don't count as a selected checkbox. List them in the reservedProperties array to exclude them
            var _reservedProperties = ['id','other_input'];
            var _numberOfProperties = Object.keys(newValue).length;

            for(var i = 0; i < _reservedProperties.length; i++) {
              if(Object.keys(newValue).indexOf(_reservedProperties[i]) !== -1) {
                _numberOfProperties--;
              }
            }

            if(scope.groupIsRequired){
              ctrl.$setValidity('groupIsRequired', (_numberOfProperties >= 1));
            }

            if(typeof scope.minCheckboxes !== "undefined" && typeof scope.minCheckboxValue !== "undefined" && scope.minCheckboxes === true){
              ctrl.$setValidity('minCountCheckboxes', (_numberOfProperties >= scope.minCheckboxValue));
            }

            if(typeof scope.maxCheckboxes !== "undefined" && typeof scope.maxCheckboxValue !== "undefined" && scope.maxCheckboxes === true){
              ctrl.$setValidity('maxCountCheckboxes', (_numberOfProperties <= scope.maxCheckboxValue));
            }

          }, true);
        }

      }
    };
  }

  angular.module('iv.iform')
    .directive('iformCountCheckboxes', iformCountCheckboxes)
})();

angular.module('iv.iform').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('scripts/directives/iform.tpl.html',
    "<div class=\"form-container\" ng-class=\"formCustomClass\"> <div class=\"form-success-message\" ng-if=\"bShowSuccessMessage\" ng-bind-html=\"formData.message\"></div> <div class=\"form-error-message\" ng-if=\"bShowErrorMessage\" ng-bind-html=\"errorMessage\"></div> <form ng-if=\"bShowForm\" name=\"validators[pageIndex]\" class=\"form form-page\" novalidate ng-repeat=\"(pageIndex, page) in formData.pages\"> <div ng-repeat=\"(blockIndex, block) in page.blocks\" ng-show=\"pageIndex === currentPage\"> <!--type header--> <div ng-if=\"block.type === 'header' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <h1 class=\"form-block-header\" ng-if=\"block.htype ==='h1'\">{{block.content}}</h1> <h2 class=\"form-block-header\" ng-if=\"block.htype ==='h2'\">{{block.content}}</h2> <h3 class=\"form-block-header\" ng-if=\"block.htype ==='h3'\">{{block.content}}</h3> <h4 class=\"form-block-header\" ng-if=\"block.htype ==='h4'\">{{block.content}}</h4> <h5 class=\"form-block-header\" ng-if=\"block.htype ==='h5'\">{{block.content}}</h5> <h6 class=\"form-block-header\" ng-if=\"block.htype ==='h6'\">{{block.content}}</h6> </div> <!--type textmsg--> <div ng-if=\"block.type === 'textmsg' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <div class=\"form-block-textmsg\" ng-bind-html=\"block.content\"></div> </div> <!--type textbox--> <div ng-if=\"block.type === 'textbox' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <label ng-if=\"settings.labelsvisible == '1'\" for=\"form-block-{{block.id}}\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</label> <input ng-minlength=\"block.min_count\" ng-maxlength=\"block.max_count\" ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].value\" type=\"text\" class=\"form-block-textbox\" ng-value=\"block.content\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\"> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type multiplechoice - radio --> <div ng-if=\"block.type === 'multiplechoice' && block.multiplechoice_type === 'radio' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <div ng-if=\"settings.labelsvisible == '1'\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</div> <div ng-repeat=\"(key, val) in block.choices\" class=\"form-block-radiobutton-wrapper\"> <input ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].choice\" ng-change=\"clearRadioOtherField(block.other_choice, form.pages[pageIndex].blocks[blockIndex]); checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex]);\" class=\"form-block-radiobutton\" type=\"radio\" name=\"{{block.id}}\" id=\"form-block-choice-{{block.id}}-{{$index}}\" ng-value=\"key\"> <label for=\"form-block-choice-{{block.id}}-{{$index}}\" class=\"form-block-option-label\">{{val}}</label> </div> <!--type multiplechoice radio - other field --> <div ng-if=\"block.other_choice\" class=\"form-block-radiobutton-wrapper form-block-radiobutton-other-wrapper\"> <input ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].choice\" ng-change=\"checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex])\" class=\"form-block-radiobutton\" type=\"radio\" name=\"{{block.id}}\" id=\"other-{{block.id}}\" value=\"other_value\"> <label class=\"form-block-other-option-label\" for=\"other-{{block.id}}\">{{block.msg_other_choice}}</label> <input ng-focus=\"setOtherChoice(form.pages[pageIndex].blocks[blockIndex], block.multiplechoice_type); checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex])\" ng-required=\"form.pages[pageIndex].blocks[blockIndex].choice === 'other_value'\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].other_input\" name=\"{{block.id}}-other\" type=\"text\" class=\"form-block-other-textbox\"> </div> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> <div ng-if=\"validators[pageIndex][block.id+'-other'].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_other_error_choice}}</div> </div> <!--type multiplechoice - checkbox --> <div ng-if=\"block.type === 'multiplechoice' && block.multiplechoice_type === 'checkbox' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <div ng-if=\"settings.labelsvisible == '1'\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</div> <div ng-repeat=\"(key, val) in block.choices\" class=\"form-block-checkbox-wrapper\"> <input iform-count-checkboxes checkbox-model=\"form.pages[pageIndex].blocks[blockIndex]\" min-checkboxes=\"block.min_checkbox\" min-checkbox-value=\"block.min_checkbox_value\" max-checkboxes=\"block.max_checkbox\" max-checkbox-value=\"block.max_checkbox_value\" group-is-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex][key]\" ng-true-value=\"'{{key}}'\" ng-false-value=\"false\" ng-change=\"checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex])\" class=\"form-block-checkbox\" type=\"checkbox\" name=\"{{block.id}}\" id=\"form-block-choice-{{block.id}}-{{$index}}\"> <label for=\"form-block-choice-{{block.id}}-{{$index}}\" class=\"form-block-option-label\">{{val}}</label> </div> <div ng-if=\"block.other_choice\" class=\"form-block-checkbox-wrapper form-block-checkbox-other-wrapper\"> <input iform-count-checkboxes checkbox-model=\"form.pages[pageIndex].blocks[blockIndex]\" min-checkboxes=\"block.min_checkbox\" min-checkbox-value=\"block.min_checkbox_value\" max-checkboxes=\"block.max_checkbox\" max-checkbox-value=\"block.max_checkbox_value\" group-is-required=\"block.required\" ng-change=\"clearCheckboxOtherField(form.pages[pageIndex].blocks[blockIndex]); checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex]);\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].other_value\" ng-true-value=\"'other_value'\" ng-false-value=\"false\" class=\"form-block-radiobutton\" type=\"checkbox\" name=\"{{block.id}}\" id=\"other-{{block.id}}\"> <label class=\"form-block-other-option-label\" for=\"other-{{block.id}}\">{{block.msg_other_choice}}</label> <input ng-focus=\"setOtherChoice(form.pages[pageIndex].blocks[blockIndex], block.multiplechoice_type)\" ng-required=\"form.pages[pageIndex].blocks[blockIndex].other_value === 'other_value'\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].other_input\" name=\"{{block.id}}-other\" type=\"text\" class=\"form-block-other-textbox\"> </div> <div ng-if=\"validators[pageIndex][block.id].$error.groupIsRequired && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> <div ng-if=\"validators[pageIndex][block.id].$error.maxCountCheckboxes && validators[pageIndex].$submitted\" class=\"iform-error-message\">Er zijn te veel keuzes aangevinkt</div> <div ng-if=\"validators[pageIndex][block.id].$error.minCountCheckboxes && validators[pageIndex].$submitted\" class=\"iform-error-message\">Er zijn te weinig keuzes aangevinkt</div> <div ng-if=\"validators[pageIndex][block.id+'-other'].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_other_error_choice}}</div> </div> <!--type multiplechoice - dropdown--> <div ng-if=\"block.type === 'multiplechoice' && block.multiplechoice_type === 'dropdown' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <label ng-if=\"settings.labelsvisible == '1'\" for=\"form-block-{{block.id}}\" class=\"form-block-label\">{{block.label}}</label> <select ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].value\" ng-options=\"key as value for (key , value) in block.choices\" ng-change=\"checkDependencies(block.dependencies, form.pages[pageIndex].blocks[blockIndex])\" class=\"form-block-select\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\"> <option ng-if=\"block.placeholder\" selected value=\"\">{{block.placeholder}}</option> </select> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type numeric--> <div ng-if=\"block.type === 'numeric' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <label ng-if=\"settings.labelsvisible == '1'\" for=\"form-block-{{block.id}}\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</label> <input iform-check-number iform-number-boundary lower-limit=\"block.min_count\" upper-limit=\"block.max_count\" ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].value\" type=\"text\" class=\"form-block-numeric\" ng-value=\"block.content\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\"> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type email--> <div ng-if=\"block.type === 'email' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <label ng-if=\"settings.labelsvisible == '1'\" for=\"form-block-{{block.id}}\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</label> <input iform-check-email ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].value\" type=\"text\" class=\"form-block-email\" ng-value=\"block.content\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\"> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type textarea--> <div ng-if=\"block.type === 'textarea' && block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <label ng-if=\"settings.labelsvisible == '1'\" for=\"form-block-{{block.id}}\" ng-class=\"{'required': block.required}\" class=\"form-block-label\">{{block.label}}</label> <textarea ng-required=\"block.required\" ng-model=\"form.pages[pageIndex].blocks[blockIndex].value\" class=\"form-block-textarea\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\">{{block.content}}</textarea> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type file--> <div ng-if=\"block.type === 'file'\" ng-show=\"block.show\" class=\"form-block form-block-datakey-{{block.datakey}}\"> <input is-required=\"block.required && block.show\" ng-model=\"form.pages[pageIndex].blocks[blockIndex]\" iform-file-input=\"form.pages[pageIndex].blocks[blockIndex]\" type=\"file\" class=\"form-block-file\" name=\"{{block.id}}\" id=\"form-block-{{block.id}}\"> <label for=\"form-block-{{block.id}}\" ng-class=\"{'required': block.required}\" class=\"form-block-label\"> <span ng-if=\"!form.pages[pageIndex].blocks[blockIndex].name\">{{block.label}}</span> <span ng-if=\"form.pages[pageIndex].blocks[blockIndex].name\">{{form.pages[pageIndex].blocks[blockIndex].name| limitTo : 35}}</span> </label> <div ng-if=\"validators[pageIndex][block.id].$invalid && validators[pageIndex].$submitted\" class=\"iform-error-message\">{{block.msg_required}}</div> </div> <!--type pagebreak--> <div ng-if=\"block.type === 'pagebreak' && block.show\" class=\"form-block form-block-pagebreak form-block-datakey-{{block.datakey}}\"> <button type=\"button\" ng-show=\"currentPage !== 0\" ng-click=\"prevPage()\" title=\"{{block.previous_label}}\" class=\"form-block-pagebreak-button form-block-previous-button\">{{block.previous_label}}</button> <button type=\"submit\" ng-click=\"nextPage()\" title=\"{{block.next_label}}\" class=\"form-block-pagebreak-button form-block-next-button\">{{block.next_label}}</button> </div> <!--type formtail--> <div ng-if=\"block.type === 'formtail' && block.show\" class=\"form-block form-block-formtail form-block-datakey-{{block.datakey}}\"> <button type=\"button\" ng-if=\"formData.pages.length > 1\" ng-click=\"prevPage()\" title=\"{{block.previous_label}}\" class=\"form-block-formtail-button form-block-previous-button\">{{block.previous_label}}</button> <button type=\"submit\" ng-click=\"send()\" title=\"{{block.next_label}}\" class=\"form-block-formtail-button form-block-next-button\">{{block.next_label}}</button> </div> </div> </form> </div>"
  );

}]);
